import { io } from 'socket.io-client'

const socket = io(process.env.REACT_APP_SERVER_SOCKET, {
  transports: ['websocket'],
  secure: true,
  withCredentials: true,
})

export default socket
